import defaultState from "./state";

const nuevaPrestacionFormReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "NUEVA_PREST/CONFIRMACION_GUARDADO_AGREGACION": {
      return Object.assign({}, state, {
        aceptaGuardadoModal: action.aceptaGuardadoModal,
      });
    }

    case "NUEVA_PREST/GUARDAR_VALOR_PRESTACIONES": {
      if (action.tipoAtencion === "H") {
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, {
              ValorH: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.value : p.ValorH,
              ValorHError: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.error : p.ValorHError,
            })),
        });
      }
      if (action.tipoAtencion === "A") {
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, {
              ValorA: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.value : p.ValorA,
              ValorAError: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.error : p.ValorAError,
            })),
        });
      }

      return Object.assign({}, state, {});
    }

    case "NUEVA_PREST/CAMBIAR_CODIGO_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoPrestacionPrestador: action.codigoPrestacionPrestador,
        codigoPrestacionPrestadorErr: "",
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_CODIGO_TIPOPRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        tipoPrestacion: action.tipoPrestacion,
        glosaPrestacionIsapre: action.glosaPrestacion,
        tipoPrestacionErr: "",
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_CODIGO_GUARISMO": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        pabellonPrestacion: action.pabellonPrestacion,
        pabellonPrestacionErr: action.pabellonPrestacion ? "" : state.detallePrestacion.pabellonPrestacionErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_GLOSA_PRESTACION_PRESTADOR": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        glosaPrestacionPrestador: action.glosaPrestacionPrestador,
        glosaPrestacionPrestadorErr: action.glosaPrestacionPrestador ? "" : state.detallePrestacion.glosaPrestacionPrestadorErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_INICIO_VIGENCIA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        inicioVigenciaArancel: action.inicioVigenciaArancel,
        inicioVigenciaArancelErr: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_PERTENENCIA_FONSA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        pertenenciaFonasa: action.pertenenciaFonasa,
        pertenenciaFonasaErr: action.pertenenciaFonasa ? "" : state.detallePrestacion.pertenenciaFonasaErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasa: action.codigoFonasa,
        codigoFonasaErr: action.codigoFonasa ? "" : state.detallePrestacion.codigoFonasaErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_ITEM_IMED": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        itemImed: action.itemImed,
        itemImedErr: action.itemImed || action.itemImed === 0 ? "" : (action.error ? action.error : state.detallePrestacion.itemImedErr),
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_TIPO_PROFESIONAL": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        tipoProfesional: action.tipoProfesional,
        tipoProfesionalErr: action.tipoProfesional ? "" : state.detallePrestacion.tipoProfesionalErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/GUARDAR_ARBOL_INICIAL": {
      const prestacionesSeleccionadas = [];
      action.tiposArancel.map((arancel) => (
        action.centrosAtencion.map((centro) => (
          prestacionesSeleccionadas.push({
            rutArancel: arancel.Rut,
            centroAtencion: centro.Secuencia,
            DescArancel: arancel.Descripcion,
            DescCentro: centro.Descripcion,
            Selected: false,
            ValorH: null,
            ValorA: null,
            UnidadH: "",
            UnidadA: "",
            ValorHError: "",
            ValorAError: "",
            UnidadHError: "",
            UnidadAError: "",
          })
        ))
      ));
      return Object.assign({}, state, {
        prestacionesSeleccionadas,
      });
    }

    case "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_HOSPITALARIO": {
      return Object.assign({}, state, {
        valorHosp: action.montoHospitalario,
      });
    }

    case "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_HOSPITALARIO_ERROR": {
      return Object.assign({}, state, {
        valorHospErr: action.montoHospitalarioError,
      });
    }

    case "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_AMBULATORIO": {
      return Object.assign({}, state, {
        valorAmb: action.montoAmbulatorio,
      });
    }

    case "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_AMBULATORIO_ERROR": {
      return Object.assign({}, state, {
        valorAmbErr: action.montoAmbulatorioError,
      });
    }

    case "NUEVA_PREST/CHECK_ROWS": {
      if (action.rutArancel) {
        if (action.centroAtencion || action.centroAtencion === 0) {
          return Object.assign({}, state, {
            prestacionesSeleccionadas: state.prestacionesSeleccionadas
              .map((p) => Object.assign({}, p, {
                Selected: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                  action.checked : p.Selected,
              })),
          });
        }
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, {
              Selected: action.rutArancel === p.rutArancel ? action.checked : p.Selected,
            })),
        });
      }
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas
          .map((p) => Object.assign({}, p, { Selected: action.checked })),
      });
    }

    case "NUEVA_PREST/CAMBIAR_UNIDAD_GRILLA": {
      if (action.tipoAtencion === "H") {
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, {
              UnidadH: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.value : p.UnidadH,
              UnidadHError: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.error : p.UnidadHError,
            })),
        });
      }
      if (action.tipoAtencion === "A") {
        return Object.assign({}, state, {
          prestacionesSeleccionadas: state.prestacionesSeleccionadas
            .map((p) => Object.assign({}, p, {
              UnidadA: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.value : p.UnidadA,
              UnidadAError: action.rutArancel === p.rutArancel && action.centroAtencion === p.centroAtencion ?
                action.error : p.UnidadAError,
            })),
        });
      }

      return Object.assign({}, state, {});
    }

    case "NUEVA_PREST/LIMPIAR_ERROR_GRILLA_UNSELECT": {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas
          .map((p) => Object.assign({}, p, {
            ValorHError: !p.Selected ? "" : p.ValorHError,
            ValorAError: !p.Selected ? "" : p.ValorAError,
            UnidadHError: !p.Selected ? "" : p.UnidadHError,
            UnidadAError: !p.Selected ? "" : p.UnidadAError,
          })),
      });
    }

    case "NUEVA_PREST/EDIT_MOD/DISPLAY_ERROR_TEXT": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoPrestacionPrestadorErr: action.Errors.codigoPrestacionPrestadorErr,
        glosaPrestacionPrestadorErr: action.Errors.GlosaPrestacionErr,
        tipoProfesionalErr: action.Errors.CodProfesionalErr,
        inicioVigenciaArancelErr: action.Errors.InicioVigenciaArancelErr,
        tipoPrestacionErr: action.Errors.TipoPrestacionErr,
        pabellonPrestacionErr: action.Errors.PabellonPrestacionErr,
        pertenenciaFonasaErr: action.Errors.PertenenciaFonasaErr,
        codigoFonasaErr: action.Errors.CodigoFonasaErr,
        itemImedErr: action.Errors.ItemImedErr,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CAMBIAR_UNIDAD_REPLICAR": {
      return Object.assign({}, state, {
        tipoUnidadReplicar: action.tipoUnidad,
      });
    }

    case "NUEVA_PREST/CARGAR_VALOR_MAX_PRES": {
      const valorMaxPresAux = action.valorMaxPres;
      return Object.assign({}, state, {
        valorMaxPres: valorMaxPresAux,
      });
    }

    case "NUEVA_PREST/LIMPIAR_PRESTACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoPrestacionPrestador: null,
        tipoPrestacion: null,
        pabellonPrestacion: null,
        glosaPrestacionPrestador: null,
        inicioVigenciaArancel: null,
        pertenenciaFonasa: null,
        codigoFonasa: null,
        itemImed: null,
        tipoProfesional: null,
        tipoUnidad: null,

        grupoPrestacionIsapre: "",
        codigoPrestacionIsapre: "",
        glosaPrestacionIsapre: "",
        montoArancelPrestacion: "",
        tipoAtencion: "",

        codigoPrestacionPrestadorErr: null,
        tipoPrestacionErr: null,
        pabellonPrestacionErr: null,
        glosaPrestacionPrestadorErr: null,
        inicioVigenciaArancelErr: null,
        pertenenciaFonasaErr: null,
        codigoFonasaErr: null,
        itemImedErr: null,
        tipoProfesionalErr: null,
        tipoUnidadErr: null,
        grupoPrestacionIsapreErr: "",
        codigoPrestacionIsapreErr: "",
        glosaPrestacionIsapreErr: "",
        montoArancelPrestacionErr: "",
        tipoAtencionErr: "",

        codigoFonasaValid: null,
      });

      const prestacionesSeleccionadas = [];
      return Object.assign({}, state, {
        detallePrestacion,
        prestacionesSeleccionadas,
        valorHosp: "",
        valorAmb: "",
        valorHospErr: "",
        valorAmbErr: "",
        tipoUnidadReplicar: null,
      });
    }

    case "NUEVA_PREST/SET_VALIDACION_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasaValid: action.valid,
        codigoFonasaErr: !action.valid ? "Código no es válido" : "",
        codigoFonasaGlosa: action.valid ? action.codigoGlosa : "",
      });

      detallePrestacion.codigoFonasaErr = action.hasMinLength ? detallePrestacion.codigoFonasaErr : "Mínimo 6 caracteres"

      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/CLEAR_CODIGO_FONASA": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        codigoFonasaErr: null,
        codigoFonasaValid: null,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    case "NUEVA_PREST/LOADING_VALIDACION_CODIGO_FONASA": {
      return Object.assign({}, state, {
        codigoFonasaLoading: action.isLoad,
      });
    }

    case "NUEVA_PREST/VALIDAR_GUARISMO": {
      return Object.assign({}, state, {
        validarGuarismo: action.validar,
      });
    }

    case "NUEVA_PREST/CARGAR_TIPOS_ARANCEL": {
      return Object.assign({}, state, {
        tiposArancel: action.tiposArancel,
      });
    }

    case "NUEVA_PREST/ADD_ERROR_PRESTACION": {
      const prestacionesSeleccionadas = state.prestacionesSeleccionadas.map((p, i) => {
        //console.log("idArrPrestacion", action.idArrPrestacion)
        if (i == action.idArrPrestacion && action.unidad == 'VE') {
          if (action.tipoAtencion == 'A') {
            p.hasAnError = true;
          }

          if (action.tipoAtencion == 'H') {
            p.hasAnErrorH = true;
          }
        }

        return p;
      })

      return Object.assign({}, state, {
        prestacionesSeleccionadas
      });
    }

    case "NUEVA_PREST/REMOVE_ERROR_PRESTACION": {
      const prestacionesSeleccionadas = state.prestacionesSeleccionadas.map((p, i) => {
        if (i == action.idArrPrestacion) {
          p.hasAnError = false;
          p.hasAnErrorH = false;
        }

        return p;
      })

      return Object.assign({}, state, {
        prestacionesSeleccionadas
      });
    }

    case 'NUEVA_PREST/CHANGE_FONASA_IN_ALL_PRESTS': {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas.map(p => {
          if (typeof p.hasAnError != 'undefined') p.hasAnError = false;
          else if (typeof p.hasAnErrorH != 'undefined') p.hasAnErrorH = false;
          return p;
        })
      });
    }

    case 'NUEVA_PREST/CHECK_FOR_FONASA_ERRORS_IN_PRESTS': {
      return Object.assign({}, state, {
        tipoUnidadReplicar: state.tipoUnidadReplicar == 'VE' ? null : state.tipoUnidadReplicar,
        prestacionesSeleccionadas: state.prestacionesSeleccionadas.map(p => {
          if (p.UnidadA == 'VE') {
            p.hasAnError = true;
            p.UnidadA = null;
          }

          if (p.UnidadH == 'VE') {
            p.hasAnErrorH = true;
            p.UnidadH = null;
          }

          return p;
        }),
      });
    }

    case 'NUEVA_PREST/CLEAN_ERRORS_IN_PRESTS': {
      return Object.assign({}, state, {
        prestacionesSeleccionadas: state.prestacionesSeleccionadas.map(p => {
          p.hasAnError = false;
          p.hasAnErrorH = false;

          return p;
        })
      });
    }

    default:
      return state;
  }
};

export default nuevaPrestacionFormReducer;



// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/NuevaPrestacionForm/reducer.js